<template lang="pug">
  .map-title
    .title-container
      .title(ref="title1")
        .titles.title-1
          img(src="~assets/scenes/scene1copy01.png")
        .titles.title-2
          img(src="~assets/scenes/scene1copy02.png")
        .titles.title-3
          img(src="~assets/scenes/scene1copy03.png")
        .subtitle
          img(src="~assets/scenes/scene1copysub.png")
      .title(ref="title2")
        .titles.title-1
          img(src="~assets/scenes/scene2copy01.png")
        .titles.title-2
          img(src="~assets/scenes/scene2copy02.png")
        .titles.title-3
          img(src="~assets/scenes/scene2copy03.png")
        .subtitle
          img(src="~assets/scenes/scene2copysub.png")
      .title(ref="title3")
        .titles.title-1
          img(src="~assets/scenes/scene3copy01.png")
        .titles.title-2
          img(src="~assets/scenes/scene3copy02.png")
        .titles.title-3
          img(src="~assets/scenes/scene3copy03.png")
        .subtitle
          img(src="~assets/scenes/scene3copysub.png")
      .title(ref="title4")
        .titles.title-1
          img(src="~assets/scenes/scene4copy01.png")
        .titles.title-2
          img(src="~assets/scenes/scene4copy02.png")
        .titles.title-3
          img(src="~assets/scenes/scene4copy03.png")
        .subtitle
          img(src="~assets/scenes/scene4copysub.png")
      .title(ref="title5")
        .titles.title-1
          img(src="~assets/scenes/scene5copy01.png")
        .titles.title-2
          img(src="~assets/scenes/scene5copy02.png")
        .titles.title-3
          img(src="~assets/scenes/scene5copy03.png")
        .subtitle
          img(src="~assets/scenes/scene5copysub.png")



</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3} from 'gsap'
import * as MODES from 'src/config/modes'
import Raf from 'src/helpers/Raf'
import AnalyticsService from '@/services/AnalyticsService'
//import Component from '@/components/Component'

export default {
  name: "MapTitle",
  props: {
    prop: {
      default: false,
      required: false
    }
  },
  components: {
    //Component
  },
  data() {
    return {
      t:{
        t1: 0,
        t2: -1,
        t3: -1,
        t4: -1,
        t5: -1,
      },
      p:{
        p1: 0,
        p2: 1,
        p3: 1,
        p4: 1,
        p5: 1,
      },
      dtEl:[],
      lastIdx: 0,
      order: [
        [0, 1, 2],
        [0, 2, 1],
        [0, 2, 1],
        [0, 2, 1],
        [0, 2, 1],

      ],
      preDefault: false,
      gtags: [
        'yosemite',
        'redwoods',
        'santabarbara',
        'montereybay',
        'lajolla'
      ],

    }
  },
  computed:{
    ...mapState('app', ['mode', 'mapProgress', 'currSceneIdx', 'sceneEntered']),

  },
  methods: {
    ...mapMutations('app', ['lockMode', 'unlockMode']),
    init() {},
    animate() {},

    update(){




      //let dx = this.tarPos[0] - this.curPos[0]
      //let dy = this.tarPos[1] - this.curPos[1]
      //this.curPos[0] += dx*this.p
      //this.curPos[1] += dy*this.p
      //console.log(999, this.curPos[0].toFixed(1), this.curPos[1].toFixed(1))
    },
    toSceneState(tl, id){
      this.t.t1 = 0
      this.t.t2 = 0
      this.t.t3 = 0
      this.t.t4 = 0
      this.t.t5 = 0
      for (let i=0;i<5;i++){
        if (i === id) continue
        let _title = this.$refs[`title${i+1}`]
        let _t1 = _title.childNodes[this.order[i][0]]
        let _t2 = _title.childNodes[this.order[i][1]]
        let _t3 = _title.childNodes[this.order[i][2]]
        let _t4 = _title.childNodes[3]
        tl.set(
          _t1,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0
          },
          `start+=0`
        )
          .set(
            _t2,
            {
              y: 50,
              scaleY: 0.5,
              opacity: 0
            },
            `start+=0`
          )
          .set(
            _t3,
            {
              scaleX: 0,
              scaleY: 0.8,
            },
            `start+=0`
          )
          .set(
            _t4,
            {
              opacity: 0
            },
            `start+=0`
          )
      }
    },
    restoreDestState(tl, id){
      this.t.t1 = 0
      this.t.t2 = -1
      this.t.t3 = -1
      this.t.t4 = -1
      this.t.t5 = -1
      for (let i=0;i<5;i++){
        if (i === id) continue
        let _title = this.$refs[`title${i+1}`]
        let _t1 = _title.childNodes[this.order[i][0]]
        let _t2 = _title.childNodes[this.order[i][1]]
        let _t3 = _title.childNodes[this.order[i][2]]
        let _t4 = _title.childNodes[3]
        tl.set(
          _t1,
          {
            y: 0,
            scaleY: 1,
            opacity: 1
          },
          `start+=0`
        )
          .set(
            _t2,
            {
              y: 0,
              scaleY: 1,
              opacity: 1
            },
            `start+=0`
          )
          .set(
            _t3,
            {
              scaleX: 1,
              scaleY: 1,
            },
            `start+=0`
          )
          .set(
            _t4,
            {
              opacity: 1
            },
            `start+=0`
          )
      }
    },
    preventDefault(){
      this.preDefault = true
    },
    //back to dest selector from ending
    animeIntro(id){
      this.preDefault = false
      let title = this.$refs[`title${id+1}`]
      let t1 = title.childNodes[this.order[id][0]]
      let t2 = title.childNodes[this.order[id][1]]
      let t3 = title.childNodes[this.order[id][2]]
      let t4 = title.childNodes[3]



      let tl = new TimelineMax({ onComplete: () => {

        }
      })
      this.tl = tl
      tl.add('start')
      //this.restoreDestState(tl, id)

      tl.set(
          t1,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0
          },
          `start+=0`
        )
        .set(
          t2,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0
          },
          `start+=0`
        )
        .set(
          t3,
          {
            scaleX: 0,
            scaleY: 0.5,
          },
          `start+=0`
        )
        .set(
          t4,
          {
            opacity: 0
          },
          `start+=0`
        )
        .to(
          t4,
          0.3,
          {
            opacity: 1,
            ease: Power2.easeOut
          },
          `start+=0`
        )
        .to(
          t1,
          0.7,
          {
            y: 0,
            scaleY: 1,
            opacity: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0.3`
        )
        .to(
          t2,
          0.7,
          {
            y: 0,
            scaleY: 1,
            opacity: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0.4`
        )
        .to(
          t3,
          0.7,
          {
            scaleX: 1,
            scaleY: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0`
        )

    },
    animeIn(id, lastId){
      //console.log('99999999', id, lastId)
      if (this.tl) {
        this.tl.seek(this.tl.endTime())
        this.tl.kill()
        this.tl = null
      }

      let title = this.$refs[`title${id+1}`]
      let t1 = title.childNodes[this.order[id][0]]
      let t2 = title.childNodes[this.order[id][1]]
      let t3 = title.childNodes[this.order[id][2]]
      let t4 = title.childNodes[3]

      let _title = this.$refs[`title${lastId+1}`]
      let _t1 = _title.childNodes[this.order[lastId][0]]
      let _t2 = _title.childNodes[this.order[lastId][1]]
      let _t3 = _title.childNodes[this.order[lastId][2]]
      let _t4 = _title.childNodes[3]

      let tl = new TimelineMax({ onComplete: () => {

        }
      })
      this.tl = tl
      tl.add('start')
      //this.restoreDestState(tl, id)

      tl.set(
        _t1,
        {
          y: 50,
          scaleY: 0.5,
          opacity: 0
        },
        `start+=0`
        )
        .set(
          _t2,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0
          },
          `start+=0`
        )
        .set(
          _t3,
          {
            scaleX: 0,
            scaleY: 0.5,
          },
          `start+=0`
        )
        .set(
          _t4,
          {
            opacity: 0
          },
          `start+=0`
        )
        .set(
          t1,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0
          },
          `start+=0`
        )
        .set(
          t2,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0
          },
          `start+=0`
        )
        .set(
          t3,
          {
            scaleX: 0,
            scaleY: 0.5,
          },
          `start+=0`
        )
        .set(
          t4,
          {
            opacity: 0
          },
          `start+=0`
        )
        .to(
          t4,
          0.3,
          {
            opacity: 1,
            ease: Power2.easeOut
          },
          `start+=0`
        )
        .to(
          t1,
          0.7,
          {
            y: 0,
            scaleY: 1,
            opacity: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0.3`
        )
        .to(
          t2,
          0.7,
          {
            y: 0,
            scaleY: 1,
            opacity: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0.4`
        )
        .to(
          t3,
          0.7,
          {
            scaleX: 1,
            scaleY: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0`
        )

    },
    animeOut(id){

      let title = this.$refs[`title${id+1}`]
      let t1 = title.childNodes[this.order[id][0]]
      let t2 = title.childNodes[this.order[id][1]]
      let t3 = title.childNodes[this.order[id][2]]
      let t4 = title.childNodes[3]
      let tl = new TimelineMax({ onComplete: () => {

        }
      })
      this.tl = tl
      tl.add('start')
      //this.toSceneState(tl, id)
      tl.to(
          t1,
          0.7,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0.3`
        )
        .to(
          t2,
          0.7,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0.4`
        )
        .to(
          t3,
          0.7,
          {
            scaleX: 0,
            scaleY: 0.8,
            ease: Back.easeIn.config(2.5)
          },
          `start+=0`
        )
        .to(
          t4,
          0.3,
          {
            opacity: 0,
            ease: Linear.easeNone
          },
          `start+=0.7`
        )


    },

    playScene(){
      if (this.mode === MODES.KIDS){
        window.GyroView.monsterIn()
        window.Cam.animateIn()
        window.Bag.animateIntro()
      }
      else{
        window.AVPlayer.playSoundFromStart(0, this.currSceneIdx)
        this.unlockMode()
      }
    },
    animeInOut(id){
      this.lockMode()
      if (this.tl) {
        this.tl.seek(this.tl.endTime())
        this.tl.kill()
        this.tl = null
      }
      let title = this.$refs[`title${id+1}`]
      //console.log(title)
      let t1 = title.childNodes[this.order[id][0]]
      let t2 = title.childNodes[this.order[id][1]]
      let t3 = title.childNodes[this.order[id][2]]
      let t4 = title.childNodes[3]
      let tl = new TimelineMax({ onComplete: () => {
          this.playScene()
        }
      })
      this.tl = tl
      tl.add('start')

        .to(
          t4,
          0.3,
          {
            opacity: 1,
            ease: Linear.easeNone
          },
          `start+=0`
        )
        .to(
          t1,
          0.7,
          {
            y: 0,
            scaleY: 1,
            opacity: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0.3`
        )
        .to(
          t2,
          0.7,
          {
            y: 0,
            scaleY: 1,
            opacity: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0.4`
        )
        .to(
          t3,
          0.7,
          {
            scaleX: 1,
            scaleY: 1,
            ease: Back.easeOut.config(2.5)
          },
          `start+=0`
        )

        .to(
          t1,
          0.5,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0,
            ease: Back.easeIn.config(2.5)
          },
          `start+=2.3`
        )
        .to(
          t2,
          0.5,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0,
            ease: Back.easeIn.config(2.5)
          },
          `start+=2.4`
        )
        .to(
          t3,
          0.5,
          {
            scaleX: 0,
            scaleY: 0.8,
            ease: Back.easeIn.config(3)
          },
          `start+=2`
        )
        .to(
          t4,
          0.3,
          {
            opacity: 0,
            ease: Linear.easeNone
          },
          `start+=2.5`
        )
    },

    showFirstTitle(){

      for (let i=0;i<5;i++){
        let _title = this.$refs[`title${i+1}`]
        let _t1 = _title.childNodes[this.order[i][0]]
        let _t2 = _title.childNodes[this.order[i][1]]
        let _t3 = _title.childNodes[this.order[i][2]]
        let _t4 = _title.childNodes[3]
        let tl = new TimelineMax({ onComplete: () => {
          }
        })
        tl.set(
          _t1,
          {
            y: 50,
            scaleY: 0.5,
            opacity: 0
          },
          `start+=0`
        )
          .set(
            _t2,
            {
              y: 50,
              scaleY: 0.5,
              opacity: 0
            },
            `start+=0`
          )
          .set(
            _t3,
            {
              scaleX: 0,
              scaleY: 0.8,
            },
            `start+=0`
          )
          .set(
            _t4,
            {
              opacity: 0
            },
            `start+=0`
          )
      }


    },
    cleanTimeline(){
      if (this.tl) {
        this.tl.seek(this.tl.endTime())
        this.tl.kill()
        this.tl = null
      }
    }
  },
  mounted() {
    window.MapTitle = this

    this.showFirstTitle()



  },
  beforeDestroy(){
    //Raf.remove(this.update)
  },
  watch: {
    // mode(){
    //   if (this.tl) {
    //     this.tl.seek(this.tl.endTime())
    //     this.tl.kill()
    //     this.tl = null
    //   }
    //   setTimeout(() => {
    //     this.animeInOut(this.currSceneIdx)
    //   },1000)
    //
    // },
    currSceneIdx(val){
      if (this.preDefault) {
        this.lastIdx = val
        return
      }

      if (this.sceneEntered){
        //if (this.mode === MODES.KIDS) return

        this.cleanTimeline()

        if (this.lastIdx === val && val === 4){
          window.Scene.panLimit()
          this.lastIdx = val
          return
        }
        if (val === 5)  {
          AnalyticsService.sendPageview(`/ending`)
          window.Scene.restoreLimit()
          return
        }
        this.lastIdx = val
        this.animeInOut(val)

        AnalyticsService.sendPageview(`/scene/${this.mode===MODES.KIDS? 'kids': 'adults'}/0${val+1}-${this.gtags[val]}`)


      } else{
        // if (val === 0 && this.lastIdx === 4) {
        //   this.lastIdx = val
        //   return
        // }
        this.animeIn(val, this.lastIdx)
        AnalyticsService.sendPageview(`/destinations/0${val+1}-${this.gtags[val]}`)

       }

      this.lastIdx = val
    },

  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .map-title
    //width: 0.8rem
    line-height: 0
    +full()
    pointer-events: none
    display: flex
    justify-content: center
    align-items: center
    .title-container
      margin-top: -1.25rem
      position: relative
      //background: #e15125
      .title
        transform-origin: center
        position: absolute
        top: 0
        left: 0
        display: flex
        justify-content: center
        align-items: center
        flex-direction: column
        &:first-child
          position: relative

        .titles
          width: 2.6rem
          img
            display: block
            width: 100%
            object-fit: cover

        .subtitle
          height: 0.33rem
          img
            display: inline-block
            height: 100%
            object-fit: cover





</style>